import * as React from "react";

export const EyeIcon = ({ ...props }) => {
  return (
    <svg width={18} height={14} viewBox="0 0 18 14" fill="none" {...props}>
      <path
        d="M1.625 6.91S4.42 1.317 9.313 1.317C14.204 1.318 17 6.91 17 6.91S14.204 12.5 9.312 12.5c-4.892 0-7.687-5.59-7.687-5.59z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.313 9.006a2.097 2.097 0 100-4.194 2.097 2.097 0 000 4.194z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeOffIcon = ({ ...props }) => {
  return (
    <svg width={18} height={14} viewBox="0 0 18 14" fill="none" {...props}>
      <path
        d="M1 1l16 12"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.625 6.91S4.42 1.317 9.313 1.317C14.204 1.318 17 6.91 17 6.91S14.204 12.5 9.312 12.5c-4.892 0-7.687-5.59-7.687-5.59z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.313 9.006a2.097 2.097 0 100-4.194 2.097 2.097 0 000 4.194z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
